<template>
  <form-adjustments />
</template>

<script>
  import FormAdjustments from '@/components/forms/form-adjustments'

  export default {
    name: 'edit',
    components: { FormAdjustments },

    beforeRouteLeave (to, from, next) {
      next(true)
    },
  }
</script>

<style scoped>

</style>
